import { ActionKeys, ActionTypes, RidiStoreDTO } from 'app/common/ridi.store/ridi.actions';

export interface RidiState extends RidiStoreDTO {
  _initialized: boolean;
}

/* tslint:disable */
export const initialState: RidiState = {
  _initialized: false,
  platform: {
    type: undefined,
    isPc: undefined,
    isTablet: undefined,
    isMobile: undefined,
    isPaper: undefined,
    isPaperPro: undefined,
    isRidiApp: undefined,
  },
  auth: {
    isLoggedIn: undefined,
  },
  constants: {
    apiUrl: undefined,
    notificationApiUrl: undefined,
    apiToken: undefined,
    sslHostLink: undefined,
    miscUrl: undefined,
    staticUrl: undefined,
  },
  context: {
    ridiAppTheme: undefined,
    isNotUseNotificationCenter: undefined, // base_freebook_inapp.t.twig 이외에 사용 금지
  },
};

export function ridiReducer (state: RidiState = initialState, action: ActionTypes): RidiState {
  switch (action.type) {
    case ActionKeys.INITIALIZE_RIDI: {
      return {
        _initialized: true,
        ...action.payload,
      };
    }
    case ActionKeys.OTHER_ACTION: {
      return state;
    }
    default: {
      return state;
    }
  }
}

export default ridiReducer;



// WEBPACK FOOTER //
// ./common/ridi.store/ridi.reducer.ts